import { AppState, Auth0Provider } from '@auth0/auth0-react'
import history from 'history/browser'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const config = {
  domain: import.meta.env.VITE_REACT_APP_AUTH_DOMAIN?.toString() || '',
  clientId: import.meta.env.VITE_REACT_APP_AUTH_CLIENT_ID?.toString() || '',
  audience: import.meta.env.VITE_REACT_APP_AUTH_AUDIENCE?.toString()
}

const authorizationParams = {
  audience: config.audience,
  redirect_uri: window.location.origin
}

export const AuthProvider = ({ children }: Props) => {
  const onRedirectCallback = (appState: AppState | undefined) => {
    history.push(appState?.returnTo ?? window.location.pathname)
  }

  if (import.meta.env.VITE_REACT_APP_AUTH_TYPE === 'local') {
    return children
  }

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      authorizationParams={authorizationParams}
      cacheLocation='localstorage'
      useRefreshTokensFallback
      useRefreshTokens
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
